import React from 'react'
import styled from 'styled-components'

export const StyledComponent = styled(({...rest}) => <div {...rest} />)`
  height: 60px;
  padding: 0 10px;
  display: grid;
  width: 945px;
  margin: auto;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "logo user";
`

const _PageHeader_Loader_Inner = (props) => <StyledComponent {...props} />
_PageHeader_Loader_Inner.propTypes = {}
_PageHeader_Loader_Inner.className = StyledComponent

export default _PageHeader_Loader_Inner

